export default "__VITE_ASSET__DjqjF$bh__"